import { memo, useRef } from "react";
import { connect } from "react-redux";
import { addDocumentInRedux } from "../../utils/redux/actions";
import { useRequestHook } from "../../utils/hooks/hooks";
import { Button, Row, Container } from "shards-react";
import Loading from "../Loading";
import DocumentInfo from "./DocumentInfo";
import classNames from "classnames";
import { areEqual } from "react-window";
import defaultDoc from "../../assets/images/default-doc.png";

/**
 * Export a component to render a list with element rendered in table. (e.g. atcive or done documents)
 */

const RenderListItem = ({
  dispatch,
  savedDocument,
  docTypesList,
  data,
  index,
  style,
}) => {
  const {
    documentsList,
    serviceID,
    serviceType,
    displayReference,
    toggleModal,
    setConfirmDelete,
    setConfirmCancel,
    setDocument,
    setConfirmRelease,
    isApproved,
    mainModule,
    signatureEditor,
  } = data;

  const document = documentsList[index];

  const documentStatus =
    document?.infoBox?.find(
      (item) =>
        item.name && item.name.includes("Status der Unterschriftenmappe"),
    )?.value || "Unknown";

  const showDelete = !isApproved;
  const showCancel =
    !documentStatus.includes("signiert") &&
    documentStatus !== "abgebrochen" &&
    serviceType === "signature_envelopes";

  const { handleRequest } = useRequestHook();
  const overlaysRef = useRef([]);
  const classes = classNames(
    "align-items-center",
    "border-bottom",
    "p-2",
    "scroll-list-element",
    index % 2 && "bg-light",
  );

  const getSelectedDocument = (id) => {
    if (id !== savedDocument.id || savedDocument?.isEnvelope) {
      //If document is not saved - Load 1, 2 and last pages of the selected document from DB.
      dispatch(addDocumentInRedux()); //empty the docment in redux
      handleRequest(
        "post",
        "/documents/load-selected-document",
        {
          documentId: id,
          serviceType: serviceType,
          displayReference: displayReference,
          pagesToRequest: [0],
          docTypesList,
        },
        (response) => {
          if (response) {
            dispatch(addDocumentInRedux(response));
          }
        },
      );
    }
  };

  const handleButtonClick = (id, serviceID) => {
    const pathSegments = window.location.pathname.split("/");
    const number = pathSegments[pathSegments.length - 1];

    if (serviceType === "signature_envelopes" && signatureEditor && serviceID) {
      window.open(
        `/esign-veditor/?id=${id}&serviceid=${serviceID}&from=${number}`,
        "_blank",
      );
    } else {
      getSelectedDocument(id);
      toggleModal();
    }
  };

  const handleCancelDocument = (id) => {
    setDocument(id);
    setConfirmCancel(true);
  };

  const handleDeleteDocument = (id) => {
    setDocument(id);
    setConfirmDelete(true);
  };

  const handleReleaseDocument = (id) => {
    setDocument(id);
    setConfirmRelease(true);
  };

  const showReleaseOption = (document) => {
    const { infoBox } = document;
    const [ReferenceObj] = infoBox.filter((x) => x.name === "Referenz: ");
    const Reference = ReferenceObj ? ReferenceObj.value : null;
    const [StatusObj] = infoBox.filter((x) => x.name === "Status: ");
    const Status = StatusObj ? StatusObj.value : null;

    if (
      infoBox &&
      Reference &&
      Reference !== "" &&
      !Reference.includes("Bitte Referenznummer auswählen!") &&
      Status &&
      Status === 1
    ) {
      return true;
    } else {
      return false;
    }
  };

  const showOverlay = (document) => {
    const { thumbnailUrl, failed, showModal } = document;
    if (thumbnailUrl) {
      return (
        <div className="show-modal h-100">
          <img
            width="400px"
            height="570px"
            className="card-img"
            src={thumbnailUrl}
            alt={document.documentId}
            onError={(e) => {
              e.target.alt = "Das Bild kann nicht gefunden werden!";
              e.target.src = defaultDoc;
            }}
          />
          <div
            className="show-modal-overlay w-100 h-100"
            ref={(ref) => (overlaysRef.current[index] = ref)}
          >
            {showModal && (
              <Button
                className="text-uppercase text-white"
                theme="success"
                outline
                onClick={() =>
                  handleButtonClick(document.documentId, serviceID)
                }
              >
                dokument öffnen
              </Button>
            )}
            {showCancel && isApproved && (
              <Button
                className="text-uppercase text-white mt-3"
                theme="danger"
                outline
                onClick={() => handleCancelDocument(document.documentId)}
              >
                dokument abbrechen
              </Button>
            )}
            {showDelete && (
              <Button
                className="text-uppercase text-white mt-3"
                theme="danger"
                outline
                onClick={() => handleDeleteDocument(document.documentId)}
              >
                dokument löschen
              </Button>
            )}
            {mainModule["-submitFromList"] &&
              showReleaseOption(document) &&
              showDelete && (
                <Button
                  className="text-uppercase text-white mt-3"
                  theme="success"
                  outline
                  onClick={() => handleReleaseDocument(document.documentId)}
                >
                  dokument freigeben
                </Button>
              )}
          </div>
        </div>
      );
    } else {
      if (failed) {
        const cssCLasses = classNames(
          "d-flex justify-content-center align-items-center",
          "m-0 h-100 bg-white show-modal",
        );
        return (
          <Container fluid className={cssCLasses} style={{ width: 270 }}>
            <div
              className="show-modal-overlay w-100 h-100"
              ref={(ref) => (overlaysRef.current[index] = ref)}
            >
              {showDelete && (
                <Button
                  className="text-uppercase text-white mt-3"
                  theme="danger"
                  outline
                  onClick={() => handleDeleteDocument(document.documentId)}
                >
                  dokument löschen
                </Button>
              )}
            </div>
          </Container>
        );
      } else {
        return (
          <Loading
            classes={"m-0 h-100 bg-white show-modal"}
            style={{ width: 270 }}
          />
        );
      }
    }
  };

  return (
    <Row noGutters className={classes} style={style}>
      {showOverlay(document)}
      <DocumentInfo {...document} />
    </Row>
  );
};

/**
 * Take the id of saved in redux document and return it
 * in components props.
 */
const mapStateToProps = ({ savedDocument, docTypesList }) => ({
  savedDocument,
  docTypesList,
});

export default connect(mapStateToProps)(memo(RenderListItem, areEqual)); //Export component and connect it with redux.
